module.exports = __webpack_public_path__ + "static/fonts/ziemann-icons.7808866b.woff";